const React = require("react");
const {Drawer} = require("@material-ui/core");
const withState = require("../../../../../../../../../../utils/withState");
const Ripple = require("../../../../../../../../../dumb/Ripple");
const {default: TuneIcon} = require("@material-ui/icons/Tune");
const MobileDrawer = require("./components/MobileDrawer");

module.exports = withState((setState) => {
  return ({filtersOpen}, {mobileClassName, additionalComponents, ...props}) => {

    const toggleFiltersMenu = () => setState({filtersOpen: !filtersOpen});

    return (
      <>
        <Drawer open={filtersOpen} onClose={toggleFiltersMenu}>
          <MobileDrawer {...props} onClose={toggleFiltersMenu} />
        </Drawer>
        <div className="wAuto layoutRow jcSB aiC mb10 pt10">
          <div className="pb10">
            <Ripple
              className={
                `layoutRow fhaC fvaC h45 wmin76 ph10 bs b1 bc0 r9 f12 fw4 ttU lh lts0em tdN olN dn`
              }
              onClick={toggleFiltersMenu}
            >
              <TuneIcon className="dB" />
              <span className="ml10">Filters</span>
            </Ripple>
          </div>
          <div>
            {additionalComponents}
          </div>
        </div>
      </>
    )
  }
});
